import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";

type TrustedSessionPayload = {
  sessionId: string;
};

export type TrustedOperationResult = {
  correlationId: string;
  createdCount: number;
};

async function invokeSessionOperation(
  functionName: string,
  payload: TrustedSessionPayload,
): Promise<TrustedOperationResult> {
  if (!functions) {
    throw new Error("Firebase Functions n'est pas configuré.");
  }

  const callable = httpsCallable<TrustedSessionPayload, TrustedOperationResult>(
    functions,
    functionName,
  );
  const result = await callable(payload);
  return result.data;
}

export function requestSessionDeliverablesTrusted(
  sessionId: string,
): Promise<TrustedOperationResult> {
  return invokeSessionOperation("requestSessionDeliverables", { sessionId });
}

export function queueSessionDeliverableEmailsTrusted(
  sessionId: string,
): Promise<TrustedOperationResult> {
  return invokeSessionOperation("queueSessionDeliverableEmails", { sessionId });
}
